import { createFileRoute } from "@tanstack/react-router";
import { ConceptDetailRoute } from "./-concept-detail-route";

export const Route = createFileRoute("/_app/semantic-platform/concepts/$id")({
  component: ConceptDetailPage,
});

function ConceptDetailPage() {
  const { id } = Route.useParams();
  return <ConceptDetailRoute conceptId={id} />;
}
